// extracted by mini-css-extract-plugin
module.exports = {"subPreHeader":"SubHeader_subPreHeader__2KtDL","preHeader":"SubHeader_preHeader__3R1EI","separatorImage":"SubHeader_separatorImage__1yYRD"};